export default "__VITE_ASSET__BqCsVGzl__"